module.exports = __webpack_public_path__ + "media/assets/images/plan01-5c6f6831bf315f5c52dc7e872e58db83.png";